import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Tabs, message as toaster } from 'antd';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box } from 'atoms';
import { VendorDetailsForm } from 'components/forms/vendor';
import { getClientList } from 'store/clientSlice';
import { VendorAllSectionForm, VendorVRFForm } from 'components/forms';

export default function CreateVendorSection() {
	const [formData, setFormData] = useState({});
	const [activeTab, setActiveTab] = useState(1);
	const [searchParams, setSearchParams] = useSearchParams();
	const dispatch = useDispatch();
	const { id } = useParams();

	const onChange = useCallback(
		(key) => {
			const findNotEmptyJson = JSON.stringify(formData) !== '{}';
			/**
			 * On Edit mode only allow to go other other tabs
			 */
			console.log('key ', key);
			if (id && key > 2 && findNotEmptyJson && !formData?.banking_info?.acc_number) {
				if (key > 1) {
					key = 2;
				}
				const newQueryParameters = new URLSearchParams();
				setSearchParams({
					...newQueryParameters,
					tab: key,
					// isEdit: searchParams.get('isEdit') || false,
				});
				setActiveTab(key);
				toaster.error(
					'Please complete "Required Details" page to move to "VRF Details" page.'
				);
			}
			if (id && key === 2) {
				setActiveTab(2);
			}
			if (id && findNotEmptyJson) {
				const newQueryParameters = new URLSearchParams();
				console.log('newQueryParameters', newQueryParameters);
				setSearchParams({
					...newQueryParameters,
					tab: key,
					// isEdit: searchParams.get('isEdit') || false,
				});
				setActiveTab(key);
			}
			if (key === 2 && findNotEmptyJson && !id) {
				toaster.error(
					'Please complete "Vendor Details" page to move to "Required Details" page.'
				);
			}
		},
		[id, setSearchParams, searchParams, formData?.banking_info?.acc_number]
	);

	useEffect(() => {
		const tab = Number(searchParams.get('tab'));
		console.log('Client Form tab', tab);

		if (tab) {
			onChange(tab);
		}
	}, [onChange, searchParams]);

	useEffect(() => {
		console.log('Client Form activeTab', activeTab);
	}, [activeTab]);

	useEffect(() => {
		if (id) {
			console.log('id 2', id);

			dispatch(
				getClientList({
					search_type: 'vendor',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				console.log('res', res?.data?.[0]);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	console.log('formData', formData);

	const tabs = useMemo(
		() =>
			formData?.vendor_type === 'regular'
				? [
						{
							id: 1,
							label: 'Vendor Details',
							form: (
								<VendorDetailsForm
									isEditMode={Boolean(formData?.id)}
									otherFormsData={formData}
									formData={formData}
									activeTab={activeTab}
								/>
							),
						},
						{
							id: 2,
							label: 'Required Details',
							form: (
								<VendorAllSectionForm
									isEditMode={Boolean(formData?.id)}
									otherFormsData={formData}
									formData={formData}
									activeTab={activeTab}
								/>
							),
						},
						{
							id: 3,
							label: 'VRF Details',
							form: (
								<VendorVRFForm
									isEditMode={Boolean(formData?.id)}
									otherFormsData={formData}
									formData={formData}
									activeTab={activeTab}
								/>
							),
						},
				  ]
				: [
						{
							id: 1,
							label: 'Vendor Details',
							form: (
								<VendorDetailsForm
									isEditMode={Boolean(formData?.id)}
									otherFormsData={formData}
									formData={formData}
									activeTab={activeTab}
								/>
							),
						},
						{
							id: 2,
							label: 'Required Details',
							form: (
								<VendorAllSectionForm
									isEditMode={Boolean(formData?.id)}
									otherFormsData={formData}
									formData={formData}
									activeTab={activeTab}
								/>
							),
						},
				  ],
		[activeTab, formData]
	);

	return (
		<Box>
			<Tabs
				onChange={onChange}
				tabPosition="left"
				type="line"
				activeKey={activeTab}
				defaultActiveKey={1}
				items={tabs.map((tab) => ({
					label: `${tab.id}. ${tab.label}`,
					key: tab.id,
					children: tab.form,
				}))}
			/>
		</Box>
	);
}
